import { useRouter } from 'next/router'
import { DuplicateMapButton as Button } from 'ui-components'
import { useAuth, useFederatedAuth } from 'user-auth'

import { useMapNavStore } from '~map-preview/states/mapNav'

export const DuplicateMapButton = () => {
  const router = useRouter()
  const { setOpenDrawer, setSideBar } = useMapNavStore()
  const { authenticated } = useAuth()
  const { gotoSignInPage } = useFederatedAuth()

  const handleClick = () => {
    setOpenDrawer(true)
    setSideBar('remix')
  }
  const handleSignInClick = () => {
    gotoSignInPage({
      redirect: router.asPath + '?like=true'
    })
  }

  return (
    <Button
      authenticated={authenticated}
      onClick={handleClick}
      onSignInClick={handleSignInClick}
    />
  )
}
